import {FormField} from './FormField';
import {CustomWidget} from './SharedElementsFormly';

export class DateFormly extends FormField {

  constructor() {
    super();
    super.icon="fa fa-calendar";
    super.name = 'date_' + super.generateRandomId();
    super.type = 'string';
    super.typename = 'Date';
    super.title='Date'
    super.format = 'date-time';
    this.widget.formlyConfig.templateOptions.type = 'date';
  }


}
